import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import GoBackToListButton from '../../../../../components/buttons/GoBackToListButton';
import { PathsLayouts } from '../../../../../config/routes';
import { DetailBox } from '@octano/global-ui';
import { format } from 'rut.js';
import { Postulant } from '../types';

interface HeaderProps {
  postulant: Postulant;
}

export default function Header({ postulant }: HeaderProps) {
  const { t } = useTranslation();
  return (
    <Row className="d-flex justify-content-between align-items-center mt-4">
      <Col xs={12} md={6} lg={3}>
        <GoBackToListButton path={PathsLayouts.studentFile} />
      </Col>
      <Col xs={12} md={6} lg={5}>
        <DetailBox
          columns={[
            {
              title: t('terms:student.single'),
              body: postulant.fullName,
              size: { xs: 12, md: 8 },
            },
            {
              title: t('common.forms.rut'),
              body: format(postulant.rut, { dots: true }),
              size: { xs: 12, md: 4 },
            },
          ]}
        />
      </Col>
    </Row>
  );
}
